import { LogoTopSection } from "@/react/components/Spaces/SidebarV2/LogoTopSection";

interface CommunityDropdownProps {
  isPreviewMode?: boolean;
  previewCommunityName?: string;
  previewLogoType?: "logo" | "icon";
  previewLogoUrl?: string | null;
}

export const CommunityDropdown = ({
  isPreviewMode = false,
  previewCommunityName = "",
  previewLogoType = "icon",
  previewLogoUrl = "",
}: CommunityDropdownProps) => (
  <div className={isPreviewMode ? "pointer-events-none" : undefined}>
    <LogoTopSection
      isPreviewMode={isPreviewMode}
      previewCommunityName={previewCommunityName}
      previewLogoType={previewLogoType}
      previewLogoUrl={previewLogoUrl}
    />
  </div>
);
